import { render, staticRenderFns } from "./access-user.vue?vue&type=template&id=15213c90&scoped=true&lang=pug&"
import script from "./access-user.vue?vue&type=script&lang=js&"
export * from "./access-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15213c90",
  null
  
)

export default component.exports